import { setGroupVisibility } from '@/utils/elementsGroupUtils';
import { CanvasEx } from '@/typings/canvas';
import type { ElementsGroup } from '@/typings/customilyElements/elementsGroup';
import type { ListElements } from '@/typings/customilyElements/layer';
import { ListElementType } from '@/typings/customilyElements/listElementType';

interface HandleGroupStatusProps {
    canvas: CanvasEx;
}

interface GroupProcessor {
    canvas: CanvasEx;
    relevantGroups: Set<ElementsGroup>;
}

const processCanvasElement = ({ canvas, relevantGroups }: GroupProcessor, element: ListElements): void => {
    const canvasObject = canvas.getObjects().find((obj) => obj.uuid === element.element.uuid);

    if (!canvasObject?.groupId) return;

    const group = canvas.getElementsGroups().find((g) => g.id === canvasObject.groupId);

    if (group) {
        relevantGroups.add(group);
        processChildGroups(canvas, group.id, relevantGroups);
    }
};

const processGroupElement = ({ canvas, relevantGroups }: GroupProcessor, element: ListElements): void => {
    const group = canvas.getElementsGroups().find((g) => g.uuid === element.element.uuid);

    if (group) {
        relevantGroups.add(group);
        processChildGroups(canvas, group.id, relevantGroups);
    }
};

const processChildGroups = (canvas: CanvasEx, parentId: string, relevantGroups: Set<ElementsGroup>): void => {
    const childGroups = canvas.getElementsGroups().filter((g) => g.parentId === parentId);

    childGroups.forEach((child) => relevantGroups.add(child));
};

export const handleGroupStatus = ({ canvas }: HandleGroupStatusProps, treeItems: ListElements[]): void => {
    if (!canvas || !treeItems.length) return;

    const relevantGroups = new Set<ElementsGroup>();
    const processor = { canvas, relevantGroups };

    for (const item of treeItems) {
        if (item.type === ListElementType.CanvasElement) {
            processCanvasElement(processor, item);
        } else if (item.type === ListElementType.Group) {
            processGroupElement(processor, item);
        }
    }

    if (relevantGroups.size > 0) {
        setGroupVisibility(Array.from(relevantGroups), canvas, true);
    }
};
